export default {
  title: "Regra tipo 9 - Centros de Custo elegíveis",
  subtitle: "Quais os centros de custos que fornecem recursos ($$$) para o orçamento do rateio indireto ?",
  token: "project_eligibility",
  orderBy: "value_a",
  convert: {
    param: "value_b",
    method: "boolean_to_yes_or_no",
  },
  tables: [
    {
      type: "general",
      title: "Regra geral",
      actions: "edit_remove",
      columns: [
        {
          label: "CC Destino",
          key: "value_a",
        },
        {
          label: "Nome do CC",
          key: "value_a",
          placeholder: "Todos",
          value: "*",
          convert: {
            method: "project_id_to_id_name"
          }
        },
        {
          label: "Valor elegível",
          key: "value_c",
          type: "percent",
        },
        {
          label: "Usar Todo o recurso?",
          key: "value_b",
          type: "status_to_used_money",
        },
      ],
      data: [],
    },
  ],
  drawer: {
    title: {
      insert_label: "Adicionar Regra",
      update_label: "Editar Regra",
    },
    subtitle: "Regra tipo 10 - Centros de Custo elegíveis",
    form: [
      {
        label: "Informe o Centro de Custo de destino:",
        type: "list",
        key: "value_a",
        info: "Acrescente * para selecionar todos",
        placeholder: "",
        value: "*",
        visible: false,
      },
      {
        label: "Valor elegível:",
        type: "percent",
        key: "value_c",
        placeholder: "",
        value: "*",
        visible: false,
      },
      {
        label: "Usar todo recurso?",
        type: "status_to_used_money",
        key: "value_b",
        placeholder: "",
        visible: false,
        convert: {
          method: "boolean_to_yes_or_no"
        }
      },
    ],
  },
};
